import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useMediaQuery';

const Process: React.FC = () => {
  const isMobile = useIsMobile();
  
  const MotionWrapper = ({ children, ...props }: any) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return <motion.div {...props}>{children}</motion.div>;
  };
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'Understanding the problem and researching the best solutions',
      icon: '🔍',
      color: 'bg-white'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Creating intuitive interfaces and planning the architecture',
      icon: '🎨',
      color: 'bg-white'
    },
    {
      number: '03',
      title: 'Build',
      description: 'Developing with clean code and modern technologies',
      icon: '⚙️',
      color: 'bg-white'
    },
    {
      number: '04',
      title: 'Launch',
      description: 'Testing thoroughly and deploying to production',
      icon: '🚀',
      color: 'bg-white'
    },
    {
      number: '05',
      title: 'Grow',
      description: 'Continuous updates and feature enhancements',
      icon: '📈',
      color: 'bg-white'
    }
  ];

  return (
    <section id="process" className="bg-[#F22D5E] py-24">
      <div className="container mx-auto px-6">
        <MotionWrapper
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-8">
            Our Development Process
          </h2>
          <p className="text-2xl text-white/90 max-w-4xl mx-auto">
            A streamlined approach to building exceptional applications
          </p>
        </MotionWrapper>

        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
                   <MotionWrapper
                     key={step.number}
                     initial={{ opacity: 0, y: 50 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     viewport={{ once: true }}
                     transition={{ duration: 0.8, delay: index * 0.1 }}
                     whileHover={isMobile ? {} : { y: -8, scale: 1.02 }}
                     className="bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden"
                   >
                {/* Colored header */}
                <div className={`${step.color} p-6 text-center border-b-2 border-gray-200`}>
                  <div className="text-[#333333] text-sm font-bold mb-2">{step.number}</div>
                  <div className="text-[#333333] text-3xl">{step.icon}</div>
                </div>
                
                {/* Content */}
                <div className="p-8 text-center">
                  <h3 className="text-xl font-bold text-[#333333] mb-4">{step.title}</h3>
                  <p className="text-[#333333] leading-relaxed">{step.description}</p>
                </div>
              </MotionWrapper>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
